import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useLocaleStore = defineStore('locale', () => {
  const currentLocale = ref('en')

  const setLocale = (locale) => {
    currentLocale.value = locale
  }

  watch(currentLocale, (newLocale) => {
    import('@/i18n').then(({ default: i18n }) => {
      i18n.global.locale.value = newLocale
    })
  }, { immediate: true })

  return { currentLocale, setLocale }
}, {
  persist: true
})
